import { useState } from 'react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { GOALS, isGoal } from '@/lib/goals';
import { toast } from 'sonner';
import { Target } from 'lucide-react';

// Shown when a client has no goal saved: the app asks first and never guesses one.
export function GoalRequired() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.role !== 'client' || isGoal(user.onboarding_data?.primary_goal)) return null;
  const choose = async (g) => {
    setBusy(true);
    try {
      const r = await api.put('/auth/profile', { primary_goal: g });
      await refresh?.();
      toast.success(r.data?.programme_building ? `Goal set to ${g} — building your programme now` : `Goal set to ${g}`);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save your goal'); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-[#FFB800]/40 bg-[#FFB800]/10 p-4 space-y-3" data-testid="goal-required">
      <div className="flex items-start gap-2.5">
        <Target className="w-4 h-4 text-[#FFB800] mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold text-sm">Choose your goal</div>
          <p className="text-xs text-muted-foreground mt-1">Your programme is built around your goal, so we need it before creating your plan.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {GOALS.map(g => (
          <button key={g} disabled={busy} onClick={() => choose(g)} data-testid={`goal-required-${g.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            className="px-3 py-2.5 rounded-xl text-sm font-medium border border-[var(--c-hair)] hover:border-[#FFB800] transition-colors disabled:opacity-50">
            {g}
          </button>
        ))}
      </div>
    </div>
  );
}
